<template>
  <header
    id="header"
    class="flex flex-col gap-4 items-center justify-center"
  >
    <slot />
  </header>
</template>
